import { CONTACT, NAV_LINKS, ASSETS } from "@/lib/siteData";
import { RevealLines } from "./Shared";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[var(--line)] px-6 md:px-12 pt-20 pb-10 bg-[#060606]">
    <div className="mx-auto max-w-[1500px]">
      <RevealLines
        tag="h2"
        className="font-serif-display font-light text-[13vw] md:text-[10vw] leading-[0.85] tracking-tight mb-16"
        lines={["Sanjay Kr Sinha"]}
      />

      <div className="grid grid-cols-1 md:grid-cols-4 gap-10 border-t border-[var(--line)] pt-12">
        <div className="md:col-span-2 flex items-start gap-4">
          <img src={ASSETS.logo} alt="Advocate" className="h-12 w-auto object-contain shrink-0" />
          <p className="text-[var(--off)]/60 max-w-xs leading-relaxed">
            {CONTACT.role} — {CONTACT.credentials}. {CONTACT.experience} years before the {CONTACT.court}.
          </p>
        </div>

        <div>
          <div className="font-mono-plex text-[10px] uppercase tracking-[0.24em] text-[var(--muted)] mb-5">Navigate</div>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="link-underline pb-0.5 text-[var(--off)]/80 hover:text-[var(--off)]">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="font-mono-plex text-[10px] uppercase tracking-[0.24em] text-[var(--muted)] mb-5">Contact</div>
          <ul className="space-y-3">
            <li><a href={`tel:${CONTACT.phone}`} className="link-underline pb-0.5 text-[var(--off)]/80 hover:text-[var(--off)]">{CONTACT.phoneDisplay}</a></li>
            <li><a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" className="link-underline pb-0.5 text-[var(--off)]/80 hover:text-[var(--off)]">WhatsApp</a></li>
            <li className="text-[var(--off)]/60">{CONTACT.location}</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-col md:flex-row justify-between gap-4 font-mono-plex text-[10px] uppercase tracking-[0.2em] text-[var(--muted)]">
        <span>© {new Date().getFullYear()} {CONTACT.name}. All rights reserved.</span>
        <span>Purnia · Bihar · India</span>
      </div>
    </div>
  </footer>
);
